import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import { Modal, DatePicker, Select } from 'antd'
import moment from 'moment'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading, P,
} from 'konsys-ui'
import axios from 'axios'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/tire-patch-components'
import { GET_USERS } from '../../../constants/graphql/query'
import { TIRE_PATCH_LIST } from '../../../constants/graph/query'
import { ListContainer } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const MonthReportModal = ({
  monthReportModal, setMonthReportModal, isLoading, setIsLoading, data, loading, refetch, isDataLoaded,
}) => {
  const [date, setDate] = useState()
  const [userId, setUserId] = useState()
  if (!isDataLoaded) return null
  return (
    <Modal
      title="พิมพ์บิลปะยางรายเดือน"
      visible={monthReportModal}
      onCancel={() => {
        setMonthReportModal(false)
        setDate()
        setUserId()
      }}
      onOk={() => {
        setIsLoading(true)
        window.open(
          `${getURL().FILE_SERVER}/render/pdf/tirePatchLogsByMonth?month=${moment(date).startOf('month').format('YYYY-MM-DD')}&userId=${userId}&t=${getAccessToken()}`,
          '_blank',
          'toolbar=false,scrollbars=yes,resizable=false',
        )
        setIsLoading(false)
        setMonthReportModal(false)
        setDate()
        setUserId()
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(date) || _.isUndefined(userId),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      {
        loading && _.isEmpty(data)
        && <Loading center='true'/>
      }
      {
        !(loading && _.isEmpty(data))
        && <Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          style={{ width: 334 }}
          format='MM/YYYY'
          onChange={(e) => {
            setDate(e)
          }}
        />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>ผู้บันทึก</P>
      <Select
        showSearch
        style={{ width: 334 }}
        onSelect={(e) => {
          setUserId(e)
        }}
        filterOption={false}
        onSearch={e => refetch({ name: e })}
      >
        {
          data.UserList.lists.map((v, i) => (
            <Select.Option key={v.userId} value={v.userId}>{v.firstname} {v.lastname}</Select.Option>
          ))
        }
      </Select>
      </Div>
      </Div>
      }
    </Modal>
  )
}

const Index = () => {
  const [isLoading, setIsLoading] = useState()
  const [monthReportModal, setMonthReportModal] = useState(false)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [getUsers, {
    loading, data, error, refetch,
  }] = useLazyQuery(GET_USERS)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการปะยาง</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <Button
            text='พิมพ์บิลปะยางรายเดือน'
            icon='fas fa-print'
            onClick={() => {
              setMonthReportModal(true)
              getUsers()
              setIsDataLoaded(true)
            }}
            margin='0 16px 0 0'
          />
          <DynamicButtonLink link='/tire-patch/add' condition={_.includes(window.perms, PERMISSION.CREATE_TIRE_PATCH)} props={{ text: 'บันทีกการปะยาง' }} />
        </Div>
      </Div>
      <List />
      <MonthReportModal
        monthReportModal={monthReportModal}
        setMonthReportModal={setMonthReportModal}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        isDataLoaded={isDataLoaded}
        data={data}
        loading={loading}
        refetch={refetch}
        />
    </Div>
  )
}

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(TIRE_PATCH_LIST, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
      orderField: 'updatedAt',
      orderBy: 'DESC',
    },
  })
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {(!loading || !_.isEmpty(data))
        && <Div>
          <ReactTable
            className='table'
            data={data.TirePatchLogList.lists} // *
            resizable={false}
            columns={config.columns} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(data.TirePatchLogList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {
                serialNumber: '',
                status: 'ALL',
                location: '',
                fullname: '',
              }
              await newFiltered.forEach((v) => {
                if (v.id === 'Serial.serialNumber') {
                  Object.assign(newOjb, { serialNumber: v.value })
                } else if (v.id === 'Driver.fullname') {
                  Object.assign(newOjb, { fullname: v.value })
                } else if (v.id === 'TirePatchStore.name') {
                  Object.assign(newOjb, { location: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setCurrent(0)
              refetch(newOjb)
              setVariable(newOjb)
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
        </Div>
      }
    </Wrapper>
  )
}

export default Index
